import { languageDisplayLabel, LanguagesEnum } from '@/api/enums';
import { AppIconTooltip } from '@/ui/icon-tooltip';
import { FlexContainer } from '@/ui/styled-ui';
import { Dropdown, DropdownChangeEvent } from 'primereact/dropdown';
import React, { useId } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const LabelText = styled.span`
  font-size: var(--small-font-size);
  color: var(--black-main);
`;

const getLanguageEnglishName = (lang: LanguagesEnum): string => {
  const label = languageDisplayLabel[lang] ?? String(lang);
  const match = label.match(/\[([^\]]+)\]$/);
  return match ? match[1] : label;
};

type DefaultVideoLanguageDropdownProps = {
  validLanguages: LanguagesEnum[];
  selectedLanguage?: LanguagesEnum | null;
  onChange: (language: LanguagesEnum) => void;
  isDisabled?: boolean;
  className?: string;
};

export const DefaultVideoLanguageDropdown: React.FC<
  DefaultVideoLanguageDropdownProps
> = ({ validLanguages, selectedLanguage, onChange, isDisabled, className }) => {
  const { t } = useTranslation();
  const tooltipTargetId = `default-video-language-tooltip-${useId().replace(
    /:/g,
    '',
  )}`;

  const options = validLanguages.map((lang) => ({
    id: lang,
    label: getLanguageEnglishName(lang),
  }));

  return (
    <FlexContainer
      className={className}
      justify="space-between"
      align="center"
      gap={16}
    >
      <FlexContainer align="center" gap={4} width="auto">
        <LabelText>{t('course.video.fallback.dropdown.label')}</LabelText>
        <AppIconTooltip
          target={tooltipTargetId}
          content={t('course.video.fallback.dropdown.tooltip')}
        />
      </FlexContainer>
      <Dropdown
        className="pill"
        aria-label={t('course.video.fallback.dropdown.label')}
        value={selectedLanguage ?? undefined}
        options={options}
        optionValue="id"
        optionLabel="label"
        onChange={(e: DropdownChangeEvent) => onChange(e.value)}
        disabled={isDisabled || options.length === 0}
      />
    </FlexContainer>
  );
};
